import DocHubClient from '../../../util/doc-hub-client';
import {uploadError, uploadProgress, uploadComplete} from './event-handlers';
import getOriginal from './jq-client';
import getConnection from './ms-client';

function log(message) {
	console.log('SignalR: ' + message);
}

function tryOriginal(eventHandlers) {
	log('Attempting to connect using jQuery library.');

	return getOriginal(eventHandlers)
		.then((connection) => {
			log('Connection established using jQuery SignalR.');
			DocHubClient.setConnection(connection);
		})
		.catch((...args) => console.error('Failed to connect using jQuery library.', args));
}

export default function init(store) {
	const eventHandlers = {
		uploadProgress: (m) => uploadProgress(store, m),
		uploadComplete: (m) => uploadComplete(store, m),
		uploadError: (...args) => uploadError(store, ...args)
	};

	return getConnection(eventHandlers)
		.then((connection) => {
			log('Connection established using Microsoft SignalR.');
			DocHubClient.setConnection(connection);
		})
		.catch(() => tryOriginal(eventHandlers));
}
